import { api } from '../../http';
import { AssetParameter } from '../../types/interfaces';
import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';

import Api from './api';
import IAssetParametersApi from './interfaces/assetParametersApi';

class AssetParametersApi
  extends Api<AssetParameter>
  implements IAssetParametersApi
{
  constructor(abortController: AbortController) {
    super('assetParameter/', abortController);
  }

  async getMeasures() {
    const apiCallResult = await api.get<ObjectForSelection[]>(
      'assetParameter/getMeasures',
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }

  async getByAssetType(id: number) {
    const apiCallResult = await api.get<AssetParameter[]>(
      `assetParameter/getByAssetType/${id}`,
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }

  async getForSelection() {
    const apiCallResult = await api.get<ObjectForSelection[]>(
      'assetParameter/getForSelection',
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }
}

export default AssetParametersApi;
